import {
  Paper,
  Box,
  Typography,
  Divider,
  Link,
  Button,
  Stack,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import SkeletonImage from "../ui/SkeletonImage";
import moment from "moment";

const ContentCard = ({
  id,
  title,
  image,
  date,
  description,
  category,
  onClickButton,
  buttonText,
  buttonDisabled = false,
  categoryButtonLink,
  categoryButtonText,
  type = "default",
}) => {
  return (
    <Paper
      sx={{
        p: 2,
        gap: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "0 0 10px 0 #0000000a",
        transition: "all 450ms ease",
        ":hover": {
          transform: "scale(1.01)",
          boxShadow: "0 0 10px 0 #00000021",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          overflow: "hidden",
          borderRadius: 2,
          aspectRatio: "1/0.6",
        }}
      >
        <Link
          to={type === "webinar" ? `/webinar/${id}` : `/blog/${id}`}
          component={NavLink}
        >
          <SkeletonImage src={image} />
        </Link>
      </Box>

      <Stack spacing={2} sx={{ flexGrow: 1, mt: 1 }}>
        <Divider />

        {categoryButtonLink && categoryButtonText && (
          <Button
            sx={{
              minWidth: "120px",
              width: "fit-content",
              justifyContent: "center",
              textTransform: "uppercase",
              transition: "all 350ms ease",
              ":hover": { color: "white", bgcolor: "secondary.dark" },
            }}
            size="small"
            color="secondary"
            variant="outlined"
            LinkComponent={NavLink}
            to={categoryButtonLink}
          >
            {categoryButtonText}
          </Button>
        )}

        <Link
          sx={{
            width: "100%",
            overflow: "hidden",
            WebkitLineClamp: 1,
            color: "other.color1",
            display: "-webkit-box",
            // WebkitBoxOrient: "vertical",
            transition: "all 350ms ease",
            ":hover": { color: "primary.main" },
          }}
          fontSize={20}
          fontWeight="500"
          underline="hover"
          to={type === "webinar" ? `/webinar/${id}` : `/blog/${id}`}
          component={NavLink}
        >
          {title}
        </Link>

        {description && (
          <Box
            sx={{
              overflow: "hidden",
              WebkitLineClamp: 2,
              display: "-webkit-box",
              textOverflow: "ellipsis",
              WebkitBoxOrient: "vertical",
            }}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}

        {date && (
          <Typography
            lineHeight={1}
            fontWeight={500}
            component="span"
            color="other.color2"
          >
            {moment(date).format(
              type === "webinar" ? "MMM DD YYYY [at] hh:mm A" : "MMM DD YYYY"
            )}
          </Typography>
        )}

        {onClickButton && buttonText && (
          <Button
            variant="contained"
            onClick={onClickButton}
            disabled={buttonDisabled}
          >
            {buttonText}
          </Button>
        )}
      </Stack>
    </Paper>
  );
};

export default ContentCard;
